var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextfieldMandatoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6867 4.34423C18.5467 4.58423 18.24 4.6709 18 4.5309C17.76 4.39756 17.68 4.0909 17.8133 3.8509L18.1333 3.29756H17.5C17.2267 3.29756 17 3.0709 17 2.79756C17 2.52423 17.2267 2.29756 17.5 2.29756H18.1333L17.82 1.7509C17.68 1.5109 17.76 1.20423 18 1.06423C18.24 0.930898 18.5467 1.0109 18.6867 1.2509L19 1.79756L19.3133 1.2509C19.4533 1.0109 19.76 0.930898 20 1.06423C20.24 1.20423 20.32 1.5109 20.18 1.7509L19.8667 2.29756H20.5C20.7733 2.29756 21 2.52423 21 2.79756C21 3.0709 20.7733 3.29756 20.5 3.29756H19.8667L20.1933 3.85756C20.3267 4.09756 20.2467 4.39756 20.0067 4.53756C19.7667 4.6709 19.46 4.5909 19.32 4.3509L19 3.79756L18.6867 4.34423Z",
    fill: "#04B7EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7C2.67 7 2 6.33 2 5.5C2 4.67 2.67 4 3.5 4H13.5C14.33 4 15 4.67 15 5.5C15 6.33 14.33 7 13.5 7H10V17.5C10 18.33 9.33 19 8.5 19C7.67 19 7 18.33 7 17.5V7H3.5Z",
    fill: "#04B7EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9H19.5C20.33 9 21 9.67 21 10.5C21 11.33 20.33 12 19.5 12H18V17.5C18 18.33 17.33 19 16.5 19C15.67 19 15 18.33 15 17.5V12H13.5C12.67 12 12 11.33 12 10.5C12 9.67 12.67 9 13.5 9Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextfieldMandatoryIcon);
export default __webpack_public_path__ + "static/media/TextfieldMandatoryIcon.1183356d3a7c13c9632c415140aa6726.svg";
export { ForwardRef as ReactComponent };